export default __webpack_public_path__ + "static/media/QE_1.a3dd30b7.png";